export const mgPlatformDataTransferIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 12" fill="none"><path d="M7.62498 3.70835L10.3333 0.791687M10.3333 0.791687L13.0416 3.70835M10.3333 0.791687V11.2084M6.37498 8.29169L3.66665 11.2084M3.66665 11.2084L0.958313 8.29169M3.66665 11.2084V0.791687" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'data-transfer'
}
